<patron-modal
  [visible]="visible"
  title="Aceitar politica de uso de dados"
  confirmButtonText="Sim, eu aceito"
  (confirm)="acceptTerms()"
  [confirmButtonLoading]="send"
  size="lg"
  id="acceptTermsLgpd"
  [backdrop]="'static'"
  #acceptTermsLgpd
  [closeButton]="false">
  @for (lgpdConsent of lgpdConsentsNotAccepted; track lgpdConsent) {
    <div>
      <div class="card rounded-0">
        <div class="body mx-2 my-2">
          <div class="card-title">
            <div class="row">
              <div class="col">
                {{ lgpdConsent.company?.person?.name }}
              </div>
              <div class="col d-flex justify-content-end">
                <strong>Versão: &nbsp; </strong>{{ lgpdConsent.version }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col d-flex justify-content-center">
              <h3>{{ lgpdConsent.name?.toUpperCase() }}</h3>
            </div>
          </div>
          <div [innerHTML]="lgpdConsent.content"></div>
        </div>
      </div>
    </div>
  }
</patron-modal>
